import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateDataManagementAwarenessParams {
  user: string;
  prepConductorAwarenessEnabled?: boolean;
  catalogAwarenessEnabled?: boolean;
}

export class UpdateDataManagementAwarenessRequest extends Request<IUpdateDataManagementAwarenessParams, IResult> {
  constructor(params: IUpdateDataManagementAwarenessParams) {
    super('updateShowDataManagementAwareness', params);
  }
}
